
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9mF1p", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3b0209b225ce0de8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $3b0209b225ce0de8$export$2e2bcd8739ae039 = {
    'fabric.emoji.add.custom.emoji.label': "L\xe4gg till din egen emoji",
    'fabric.emoji.add.label': "L\xe4gg till emoji",
    'fabric.emoji.cancel.label': 'Avbryt',
    'fabric.emoji.categories.label': "V\xe4lj en emojikategori",
    'fabric.emoji.categories.search.results': "S\xf6kresultat",
    'fabric.emoji.category.activity': 'Aktivitet',
    'fabric.emoji.category.all.uploads': 'Alla uppladdningar',
    'fabric.emoji.category.flags': 'Flaggor',
    'fabric.emoji.category.foods': 'Mat och dryck',
    'fabric.emoji.category.frequent': 'Vanliga',
    'fabric.emoji.category.nature': 'Natur',
    'fabric.emoji.category.objects': "F\xf6rem\xe5l",
    'fabric.emoji.category.people': 'Personer',
    'fabric.emoji.category.places': 'Resor och platser',
    'fabric.emoji.category.productivity': 'Produktivitet',
    'fabric.emoji.category.symbols': 'Symboler',
    'fabric.emoji.category.user.uploads': 'Dina uppladdningar',
    'fabric.emoji.choose.file.screenReaderDescription': "V\xe4lj en fil f\xf6r emojin. JPG, PNG eller GIF. Maxstorlek 1\xa0MB.",
    'fabric.emoji.choose.file.title': "V\xe4lj fil",
    'fabric.emoji.delete.description': "Alla befintliga f\xf6rekomster av denna emoji kommer att ers\xe4ttas med {emojiShortName}",
    'fabric.emoji.delete.label': 'Ta bort',
    'fabric.emoji.delete.screenreader.tooltip': "Tryck p\xe5 backsteg f\xf6r att radera emojin {shortName}",
    'fabric.emoji.delete.title': 'Ta bort emoji',
    'fabric.emoji.delete.tooltip': 'Radera',
    'fabric.emoji.emojipicker.emoi.roledescription': 'emojiknapp',
    'fabric.emoji.emojipicker.error': 'Fel!',
    'fabric.emoji.error.delete.failed': 'Borttagning misslyckades',
    'fabric.emoji.error.image.too.big': "Den valda bilden \xe4r st\xf6rre \xe4n 1 MB",
    'fabric.emoji.error.invalid.image': "Den valda bilden \xe4r ogiltig",
    'fabric.emoji.error.upload.failed': 'Uppladdning misslyckades',
    'fabric.emoji.error.upload.timeout': "Uppladdning \xf6verskred tidsgr\xe4nsen",
    'fabric.emoji.image.requirements': 'JPG, PNG eller GIF. Max. storlek 1 MB.',
    'fabric.emoji.name.ariaLabel': "Ange ett namn p\xe5 den nya emojin",
    'fabric.emoji.picker': "Emojiv\xe4ljare",
    'fabric.emoji.pickerlist.grid': "{showSearchResults, select, true {S\xf6kresultat} other {Emojier}}",
    'fabric.emoji.pickerlist.tabpanel': "Panel f\xf6r emoji-\xe5tg\xe4rder och -listor",
    'fabric.emoji.placeholder': 't.ex. hej',
    'fabric.emoji.preview': "Din nya emoji {emoji} ser j\xe4ttebra ut",
    'fabric.emoji.preview.title': "F\xf6rhandsgranska",
    'fabric.emoji.retry.label': "F\xf6rs\xf6k igen",
    'fabric.emoji.search.label': "Namn p\xe5 emoji",
    'fabric.emoji.search.placeholder': "S\xf6k",
    'fabric.emoji.search.status': 'Visar alla emojis',
    'fabric.emoji.select.skin.list.ariaLabel': "Hudtonsv\xe4ljare",
    'fabric.emoji.select.skin.tone.ariaLabel': "V\xe4lj din hudton, {selectedTone} har valts"
};

});


//# sourceMappingURL=sv.2514597c.js.map
